export type AIFaqAnswer = {
  paragraphs?: string[];
  list?: string[];
};

export type AIFaqEntry = {
  id: string;
  question: string;
  answer: AIFaqAnswer;
};

export const aiFaqs: AIFaqEntry[] = [
  {
    id: "what-is-ai-development",
    question: "What is AI development?",
    answer: {
      paragraphs: [
        "AI development involves building software that can understand information, generate content, analyze data, make predictions, automate tasks, or interact with users using Artificial Intelligence technologies.",
      ],
    },
  },
  {
    id: "integrate-existing-application",
    question: "Can you integrate AI into our existing application?",
    answer: {
      paragraphs: [
        "Yes. We can integrate AI capabilities into existing websites, mobile applications, SaaS products, CRMs, ERPs, databases, and APIs.",
      ],
    },
  },
  {
    id: "custom-ai-chatbot",
    question: "Can you build a custom AI chatbot?",
    answer: {
      paragraphs: [
        "Yes. We develop custom AI chatbots for customer support, sales, internal knowledge, lead generation, and other business use cases.",
      ],
    },
  },
  {
    id: "ai-agents",
    question: "Can you build AI agents?",
    answer: {
      paragraphs: [
        "Yes. We develop AI agents that can use tools, access APIs and business systems, retrieve information, and perform defined tasks based on your workflows.",
      ],
    },
  },
  {
    id: "generative-ai-applications",
    question: "Do you build Generative AI applications?",
    answer: {
      paragraphs: [
        "Yes. We build Generative AI applications using LLMs, RAG, embeddings, AI APIs, custom knowledge bases, and other modern AI technologies.",
      ],
    },
  },
  {
    id: "private-company-data",
    question: "Can you connect AI to our private company data?",
    answer: {
      paragraphs: [
        "Yes. AI applications can be connected to approved company documents, databases, APIs, and knowledge bases. The architecture can be designed around your security, access-control, and data requirements.",
      ],
    },
  },
  {
    id: "ai-development-cost",
    question: "How much does AI development cost?",
    answer: {
      paragraphs: [
        "The cost depends on the complexity of the AI solution, integrations, data requirements, model usage, user volume, and development scope. We can assess your requirements and provide an appropriate development plan and estimate.",
      ],
    },
  },
];
